module.exports = __webpack_public_path__ + "media/images/ic_number-430a6c05c786f1326ca15816c682550a.svg";